import React, { useState } from 'react';
import { Modal, Button, Typography } from '@scale/scaleui';

const PAY_COMMS_TICKET_LINK =
  'https://linear.app/scale-epd/team/COMMS/new?template=71d8b94d-0894-489a-b582-7c2c76d7c3a0';

interface PayWarningProps {
  showPayWarning: boolean;
  setShowPayWarning: (val: boolean) => void;
  onSave: () => void;
}

const PayWarning = ({ showPayWarning, setShowPayWarning, onSave }: PayWarningProps) => {
  const [showNotApprovedWarning, setShowNotApprovedWarning] = useState(false);
  return (
    <Modal
      onClose={() => setShowPayWarning(false)}
      className={'z-50'}
      innerClassName="max-w-[300px] z-50"
      open={showPayWarning}
      title="Pay Communication Warning"
      actions={
        <div className="flex justify-end gap-1 items-center">
          <Button
            variant="neutral"
            onClick={() => {
              setShowNotApprovedWarning(true);
            }}
          >
            No
          </Button>
          <Button onClick={onSave}>Yes</Button>
        </div>
      }
    >
      <div className="gap-4">
        <Typography.Paragraph2>
          Unapproved pay promises are not allowed, please file a ticket{' '}
          <a
            href={PAY_COMMS_TICKET_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="text-info-600"
          >
            here
          </a>{' '}
          and reach out to George Quraishi to make a request to send an official pay communication.
        </Typography.Paragraph2>
        <Typography.Paragraph2>Did you obtain approval already?</Typography.Paragraph2>
        {showNotApprovedWarning && (
          <Typography.Paragraph2 className="text-danger-500">
            Please obtain approval before trying to save this email template.
          </Typography.Paragraph2>
        )}
      </div>
    </Modal>
  );
};

export default PayWarning;
